import { useNavigate, useParams, Navigate } from "react-router-dom";
import { ChevronLeft, ChevronRight, List } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CATEGORIES, whiteIcon } from "@/lib/constants";
import { useLang } from "@/context/LanguageContext";


function SubGrid({ cat }) {
  const navigate = useNavigate();
  const { lang } = useLang();
  const subs = cat.subcategories;
  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-x-3 gap-y-6 mb-10" data-testid="category-subcategories-grid">
      {subs.map((sub) => (
        <button key={sub.id} onClick={() => navigate(`/category/${cat.id}/ads?sub=${sub.id}`)} data-testid={`category-page-sub-${sub.id}`} className="flex flex-col items-center gap-2 group">
          <span className={`w-[108px] h-[108px] sm:w-32 sm:h-32 rounded-full overflow-hidden shadow-sm group-hover:scale-105 transition-transform`}
            data-testid={`category-page-sub-circle-${sub.id}`}>
            <img src={`/cat/app/${sub.id}.png`} alt="" loading="lazy" className="w-full h-full object-cover" />
          </span>
          <span className="text-xs sm:text-[13px] font-semibold text-center text-[#1A5C3A] leading-tight px-0.5">{lang === "en" ? sub.name_en : sub.name_ar}</span>
        </button>
      ))}
    </div>
  );
}

export default function CategoryPage() {
  const { catId, subId } = useParams();
  const navigate = useNavigate();
  const { t, lang, dir } = useLang();
  const cat = CATEGORIES.find((c) => c.id === catId);
  const Back = dir === "rtl" ? ChevronRight : ChevronLeft;
  const nm = (i) => (lang === "en" ? i.name_en : i.name_ar);

  if (!cat) return <Navigate to="/categories" replace />;
  if (subId) return <Navigate to={`/category/${catId}/ads?sub=${encodeURIComponent(subId)}`} replace />;

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="max-w-7xl 2xl:max-w-[1600px] mx-auto px-4 sm:px-8 w-full py-6 flex-1">
        <button onClick={() => navigate("/categories")} className="text-slate-500 text-sm mb-4 flex items-center gap-1" data-testid="category-back-button">
          <Back className="w-4 h-4" /> {t("back")}
        </button>
        <div className="relative w-full h-28 rounded-[26px] overflow-hidden mb-6 bg-[#1A5C3A] shadow-md" data-testid="category-page-banner">
          <img src={cat.image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-15" />
          <div className="relative h-full flex items-center gap-4 px-6">
            <span className="w-16 h-16 rounded-full overflow-hidden border-[3px] border-white bg-white shadow-md shrink-0">
              <img src={whiteIcon(cat.thumb)} alt="" className="w-full h-full object-cover" />
            </span>
            <h1 className="font-headline text-xl sm:text-2xl font-extrabold text-white" data-testid="category-page-title">{nm(cat)}</h1>
          </div>
        </div>

        <h2 className="font-headline text-lg font-extrabold text-slate-900 mb-4">{t("subcategories_title")}</h2>
        <SubGrid cat={cat} />
        <button onClick={() => navigate(`/category/${catId}/ads`)} className="w-full max-w-xl mx-auto h-12 rounded-xl border border-[#1A5C3A] text-[#1A5C3A] font-bold flex items-center justify-center gap-2 hover:bg-[#E8EFEA] transition-colors" data-testid="subcats-all">
          <List className="w-4 h-4" /> {lang === "en" ? "All ads in this category" : "كل إعلانات القسم"}
        </button>
      </main>
      <Footer />
    </div>
  );
}
